import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { select } from '@/store'
import { isNullOrEmpty } from '@/utils'

export const useLoadListingLandlords = (listingId: string | undefined) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch.companyManagement.getCompanyListings(true)
  }, [dispatch.companyManagement])

  const landlords = useSelector(state =>
    (select.companyManagement.listingLandlords as any)(state, { listingId })
  )

  return { landlords, isLoading: isNullOrEmpty(landlords) }
}
